import React, { ComponentProps } from 'react';
import { SONHTMLContent, Wysiwyg } from './index';
import { useBlockContext } from '../../BlockFetcher';
import { useAppContext } from '../../../contexts/AppContext/AppContext';
import { CollapsibleBlock, CollapsibleBlockModifier } from '../../../components/molecules/CollapsibleBlock';
import { asView } from '../../ViewFetcher';
import { useLayoutGroupContext } from '../../../components/blocks/LayoutGroup/LayoutGroup';
import { useGlobalPrintMode } from '../../../contexts/GlobalPrintMode';

export type CollapsibleWysiwygProps = SONHTMLContent & {
  // title and string are coupled
  title?: string;
  collapsible: boolean;
};

function CollapsibleWysiwyg({ content, title, collapsible, resourceReferencesToToUrls }: CollapsibleWysiwygProps) {
  const { uuid } = useBlockContext();
  const groupLayout = useLayoutGroupContext();
  const { editModeInfo } = useAppContext();
  const { isInGlobalPrintMode } = useGlobalPrintMode();

  if (collapsible && title) {
    return (
      <CollapsibleBlock
        title={title}
        closed={!isInGlobalPrintMode}
        id={uuid}
        modifier={editModeInfo.active ? CollapsibleBlockModifier.EDITMODE : undefined}
      >
        <Wysiwyg resourceReferencesToToUrls={resourceReferencesToToUrls} content={content} groupLayout={groupLayout} />
      </CollapsibleBlock>
    );
  }

  return (
    <Wysiwyg resourceReferencesToToUrls={resourceReferencesToToUrls} content={content} groupLayout={groupLayout} />
  );
}
export const CollapsibleWysiwygView = asView(CollapsibleWysiwyg);
export type CollapsibleWysiwygView = ComponentProps<typeof CollapsibleWysiwygView>;
